import { AfterViewInit, Component, ContentChild, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ListService } from 'bookraw/shared/services/list.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTable, MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'ext-material-table',
  template: `
    <div class="table-container-outer" [class.--left-start]="leftStart" [class.table-container-outer-shadow]="showShadow">
      <div *ngIf="tableHeader" class="table-header p-15">
        <div class="item" *ngIf="tableText.length > 0">
          <h4  class="mt-8">{{ tableText }} ({{ totalListElements !== null ? totalListElements : service.paginationData?.total }})</h4>
        </div>
        <div class="item text-right">
          <ng-content select="[tableHeader]"></ng-content>
        </div>
      </div>
      <div class="table-container">
        <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
        <ng-content select="[tableBody]"></ng-content>
      </div>
      <mat-paginator
        *ngIf="!clientPagination && showPaginator"
        [length]="customPaginationData ? service[customPaginationData]?.total : service.paginationData?.total"
        [pageSize]="customPaginationData ? service[customPaginationData]?.limit : service.paginationData?.limit"
        [pageSizeOptions]="[5, 10, 25, 50, 100, 200]"
        (page)="page($event);"
        showFirstLastButtons
      ></mat-paginator>
      <mat-paginator
        #clientPaginator
        *ngIf="clientPagination && showPaginator"
        [pageSizeOptions]="[5, 10, 25, 50, 100, 200]"
        [pageSize]="defaultPageSize"
        showFirstLastButtons
      ></mat-paginator>
      <div *ngIf="tableFooter" class="table-footer p-15">
        <ng-content select="[tableFooter]"></ng-content>
      </div>
    </div>
  `,
})
export class ExtMaterialTableComponent implements AfterViewInit {

  @ViewChild('clientPaginator') paginator: MatPaginator;
  @ContentChild(MatTable) table: MatTable<any>;

  @Output() setPagePaginator: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();

  // Csak clientside paginationnél érvényes, serverside paginationnél a paginationData beállításai vannak érvényben
  @Input() defaultPageSize: number = 50;
  @Input() loading: boolean = false;
  @Input() tableHeader: boolean = false;
  @Input() tableFooter: boolean = false;
  @Input() tableText: string = '';
  @Input() service: ListService<any>;
  @Input() totalListElements: number;
  @Input() clientPagination: boolean = false;
  _tableRows: any[] = null;
  @Input() customPaginationData: string = '';
  @Input() showPaginator: boolean = true;
  @Input() showShadow: boolean = true;
  @Input() leftStart: boolean = false;

  dataSource: MatTableDataSource<any>;

  @Input() set tableRows(value: any[]) {
    this._tableRows = value;
    if (this.table) {
      this.dataSource = new MatTableDataSource(this._tableRows);
      this.dataSource.paginator = this.paginator;
      this.table.dataSource = this.dataSource;
    }
  }

  page(event: PageEvent) {
    this.setPagePaginator.emit(event);
  }

  ngAfterViewInit() {
    if (this._tableRows !== null) {
      this.tableRows = this._tableRows; // Az első beállításnál meg kell várni a view initet
    } else if (this.paginator) { // Ilyenkor a teljes listát kiírja
      console.warn(this.tableText, 'Clientside pagination with missing tableRows property on ext-material-table');
    }
  }

}
